import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { animations } from './toast.animations';

@Component({
  selector: 'app-toast',
  templateUrl: 'toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations,
})
export class ToastComponent {
  @HostBinding()
  public readonly class = 'toast-container position-fixed top-0 end-0 p-3';

  @HostBinding()
  public readonly style = 'z-index: 2200';

  public toastService: ToastService;

  constructor() {
    this.toastService = inject(ToastService);
  }

}
